module.exports = __webpack_public_path__ + "static/img/weibo705.0bba8f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/qrcode/weibo705.png
// module id = J8UZ
// module chunks = 0